import React, {useState} from 'react';
import {LogoutRounded} from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
    Typography
} from "@mui/material";
import {useNavigate} from "react-router";

const LogoutIcon = () => {
    const navigate = useNavigate();
    const [openModalExit, setOpenModalExit] = useState(false);

    function exit() {
        setOpenModalExit(false);
        navigate("/auth/logout");
    }

    return (
        <>
            <Tooltip title="خروج از حساب کاربری">
                <IconButton
                    size="small"
                    onClick={() => setOpenModalExit(true)}
                    sx={{
                        color: 'error.main',
                        borderRadius: 2,
                        '&:hover': { bgcolor: 'rgba(239, 68, 68, 0.1)' }
                    }}
                >
                    <LogoutRounded sx={{ fontSize: 20 }} />
                </IconButton>
            </Tooltip>

            <Dialog
                open={openModalExit}
                onClose={() => setOpenModalExit(false)}
                PaperProps={{
                    sx: { borderRadius: 3.5, p: 1, minWidth: 320 }
                }}
            >
                <DialogTitle sx={{ fontWeight: 800, fontSize: '1.05rem', color: 'text.primary' }}>
                    خروج از پنل سازمان
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                        آیا از خروج از حساب کاربری مدیریت سازمان اطمینان دارید؟
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenModalExit(false)}
                        sx={{ borderRadius: 2.5, px: 2.5, fontWeight: 700, borderColor: 'divider', color: 'text.secondary' }}
                    >
                        انصراف
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={exit}
                        sx={{ borderRadius: 2.5, px: 2.5, fontWeight: 700 }}
                    >
                        بله، خروج
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default LogoutIcon;
